module.exports = __webpack_public_path__ + "img/RW.dafe3468.svg";